import SELCO from '../../assets/icons/clients/selco.png';
import Jawal from '../../assets/icons/clients/jawwal.png';
import JDECO from '../../assets/icons/clients/jedco.png';
import PALTEL from '../../assets/icons/clients/paltel.png';
import UNWRWA from '../../assets/icons/clients/unwrwa.png';
import NEDCO from '../../assets/icons/clients/nedco.png';
import ANNAJAH from '../../assets/icons/clients/annajah.png';
import RAMALLAH from '../../assets/icons/clients/ramallah.png';
import PARC from '../../assets/icons/clients/parc.png';
import Ooredoo from '../../assets/icons/clients/ooredoo.png';

export const logoMap = {
  "SELCO": SELCO,
  "Jawal": Jawal,
  "JDECO": JDECO,
  "PALTEL": PALTEL,
  "UNWRWA": UNWRWA,
  "NEDCO": NEDCO,
  "An-Najah National University": ANNAJAH,
  "RAMALLAH1908": RAMALLAH,
  "PARC": PARC,
  "Ooredoo": Ooredoo
};